import React, { useState } from "react";
import { connect } from "react-redux";
import AuthActions from "../../../stores/auth/Actions";
import CustomHeader from "../../../components/CustomHeader/CustomHeader";
import CustomFooter from "../../../components/CustomFooter/CustomFooter";
import LoginForm from "../components/LoginForm";
import {
  LoginLayoutBody,
  LoginLayoutContainer,
  LogoUnoContainer,
  UnoPrimera,
} from "../styles/LoginStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import { useUpdateEffect, useMountEffect } from "../../../hooks/LifeCycle";
import unoPrimera from "../../../assets/img/uno.svg";
import { EMPRESA, LOCAL_STORAGE } from "../../../utils/Constant";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import { camposLoginValidos } from "../utils/LoginFormValidation";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import { INITIAL_STATE_LOGIN_FORM } from "../utils/LoginConstant";
import { useHistory } from "react-router-dom";

const LoginScreen = (props) => {
  const empresa = useEmpresa();

  const history = useHistory();

  const [formData, setFormData] = useState(INITIAL_STATE_LOGIN_FORM);

  const [processing, setProcessing] = useState(false);

  const [alertConfig, setAlertConfig] = useState({});

  const [showAlert, setShowAlert] = useState(false);

  const [showRequired, setShowRequired] = useState(false);

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useMountEffect(() => {
    if (props?.authUserData?.isAuth) {
      window.location.replace("/dashboard");
      return;
    }

    props.clearLogin();
  });

  /**
   * Login Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.authUserData) && processing) {
      setProcessing(false);

      localStorage.setItem(
        LOCAL_STORAGE.ESTADO_SESION.KEY,
        LOCAL_STORAGE.ESTADO_SESION.VALUE
      );

      localStorage.setItem(LOCAL_STORAGE.PSS_ACTIVO.KEY, formData.codigo);

      history.push("/dashboard");
    }
  }, [props.authUserData]);

  /**
   * Error en la autenticación.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.authUserError) && processing) {
      setProcessing(false);

      setFormData(INITIAL_STATE_LOGIN_FORM);

      const { mensaje } = props?.authUserError;

      setAlertConfig({
        type: "error",
        title: "¡Advertencia!",
        message: mensaje,
        onConfirm: () => {
          setShowAlert(false);
        },
      });

      setShowAlert(true);
    }
  }, [props.authUserError]);

  const loginUser = () => {
    const tieneSesionActiva = localStorage.getItem(
      LOCAL_STORAGE.ESTADO_SESION.KEY
    );

    const pssActivo = localStorage.getItem(LOCAL_STORAGE.PSS_ACTIVO.KEY);

    if (tieneSesionActiva === LOCAL_STORAGE.ESTADO_SESION.VALUE) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: ALERTAS_GENERICAS.SESION_ACTIVA + pssActivo,
        onConfirm: () => {
          setShowAlert(false);
          window.location.replace("/dashboard");
        },
      });

      setShowAlert(true);

      return;
    }

    if (!camposLoginValidos(formData)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
        onConfirm: () => {
          setShowAlert(false);
        },
      });

      setShowAlert(true);

      setShowRequired(true);

      return;
    }

    setProcessing(true);

    props.authUser(formData);
  };

  const handleValueChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });
    };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loginUser();
    }
  };

  const containerHeight = isPrimera ? "85vh" : "90vh";

  return (
    <LoginLayoutBody fondoEmpresa={empresa?.FONDO} isPrimera={isPrimera}>
      <CheckRender allowed={isPrimera}>
        <CustomHeader isLoginScreen={true} />
      </CheckRender>

      <LoginLayoutContainer height={containerHeight} isPrimera={isPrimera}>
        <LoginForm
          data={formData}
          onStateChange={handleValueChange}
          handleKeyPress={handleKeyPress}
          onLogin={loginUser}
          isLoading={props.authUserLoading}
          showRequired={showRequired}
        />

        <CheckRender allowed={isPrimera}>
          <LogoUnoContainer>
            <UnoPrimera src={unoPrimera} />
          </LogoUnoContainer>
        </CheckRender>

        <CheckRender allowed={props.authUserLoading}>
          <ModalLoader />
        </CheckRender>

        <CheckRender allowed={showAlert}>
          <CustomAlert {...alertConfig} />
        </CheckRender>
      </LoginLayoutContainer>

      <CustomFooter isLoginScreen={true} />
    </LoginLayoutBody>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {
  authUser: AuthActions.authUser,
  clearLogin: AuthActions.clearLogin,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(LoginScreen);
